import React from "react";
import { useTranslation } from "react-i18next";
import { AffiliatesDateRangePicker } from "../elements/AffiliatesDateRangePicker";
import { AffiliatesStatusSelect } from "../elements/AffiliatesStatusSelect";
import { IDateRange } from "../../../../store/api/affiliatesProfileApiSlice";

export const ProfileAffiliatesHeader = ({
  initLeadStatus,
  onLeadStatusChange,
  dateRange,
  setDateRange,
}: {
  initLeadStatus: string;
  onLeadStatusChange: React.Dispatch<React.SetStateAction<string>>;
  dateRange: IDateRange;
  setDateRange: React.Dispatch<React.SetStateAction<IDateRange>>;
}) => {
  const { t } = useTranslation(["profile"]);

  return (
    <div className="profile-affiliates-header">
      <div className="profile-main-content-main-title">{t("affiliates")}</div>
      <div className="profile-affiliates-header-filtes-container">
        <AffiliatesDateRangePicker
          dateRange={dateRange}
          setDateRange={setDateRange}
        />

        <AffiliatesStatusSelect
          initLeadStatus={initLeadStatus}
          onLeadStatusChange={onLeadStatusChange}
        />
      </div>
    </div>
  );
};
